<script setup>
import { ref } from 'vue';
import { router, Head } from '@inertiajs/vue3'
import JetBanner from '@/Jetstream/Banner.vue';
import AppTheming from '@/Jetstream/AppTheming.vue';

const props = defineProps({
    title: String,
});

const programme = router.page.props.programme;
const organisation = router.page.props.organisation;

const showingNavigationDropdown = ref(false);

</script>

<template>

    <AppTheming />

   <div>
        <Head :title="title" />

        <JetBanner />

        <!-- <JetApplicationHeader :programme="programme" :organisation="organisation" /> -->

        <div class="min-h-screen bg-gray-100">

            <!-- Page Heading -->
            <header v-if="$slots.header" class="bg-white shadow">
                <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <slot name="header" />
                </div>
            </header>

            <!-- Page Content -->
            <main>
                <slot />
            </main>
        </div>
    </div>
</template>
